// @flow
import React from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { IS_ROW_OPENED_FOR_EDITING, ROW_ID } from '@src/constants';
import { useEstimateVersion } from '@src/custom-hooks/useEstimateVersion';

import {
  useCreateCommittedCapacityConfigurationMutation,
  useUpdateCommittedCapacityConfigurationMutation,
} from '../../../service-definitions/estimates';
import {
  getAllDimAndNonDimConfigFieldsForEstimateCC,
  getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC,
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
  getIfGivenRowIsBeingEditedORANewOneForEstimateCC,
  getRowIdOfGivenRowForEstimateCC,
} from '../utils';
import { pickKeysFromObject } from '../../../common-utils/utils';
import { toastError } from '../../presentational/notifications/utils';
import { SaveFormButton } from '../../presentational/buttons/SaveFormButton';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';

export const CommittedCapacityDimensionsLineItemSaveContainerForEstimateCC = ({
  dimensionRow,
  metricRow,
  configuredMetrics,
  dimensionIndex,
  dimensionArrayHelpers,
}) => {
  const { estimateId } = useParams();
  const { isValid } = useFormikContext();
  const estimateVersion = useEstimateVersion();

  const [updateFunc] = useUpdateCommittedCapacityConfigurationMutation();
  const [createFunc] = useCreateCommittedCapacityConfigurationMutation();

  const isAnyOtherRowBesidesTheGivenRowBeingEdited =
    getIfAnyOtherRowBesidesTheGivenRowIsBeingEditedForEstimateCC(configuredMetrics, dimensionRow);

  const shouldUpdateButtonBeDisabled =
    !getIfGivenRowIsBeingEditedORANewOneForEstimateCC(dimensionRow) ||
    !isValid ||
    isAnyOtherRowBesidesTheGivenRowBeingEdited;

  const handleSave = async () => {
    const funcToUse = getIfGivenRowIsANewlyAddedRowForEstimateCC(dimensionRow)
      ? createFunc
      : updateFunc;
    const payload = {
      ...dimensionRow,
      metric_type: metricRow.metricName,
      resource_configuration_type: {
        ...pickKeysFromObject(
          dimensionRow,
          getAllDimAndNonDimConfigFieldsForEstimateCC(metricRow.metricName)
        ),
      },
      estimate_version: estimateVersion,
    };

    const params = {
      estimateId,
      committedCapacityId: getRowIdOfGivenRowForEstimateCC(dimensionRow),
      payload,
    };

    const { data, error } = await funcToUse(params);

    if (error) {
      toastError(error);
    } else {
      dimensionArrayHelpers.replace(dimensionIndex, {
        ...dimensionRow,
        [IS_ROW_OPENED_FOR_EDITING]: false,
        [ROW_ID]: getRowIdOfGivenRowForEstimateCC(data),
        [ESTIMATE_COMMITTED_CAPACITY.IS_ADMIN_EDITED_BACKEND_FIELD_NAME]:
          data[ESTIMATE_COMMITTED_CAPACITY.IS_ADMIN_EDITED_BACKEND_FIELD_NAME],
      });
    }
  };

  return <SaveFormButton disabled={shouldUpdateButtonBeDisabled} onClick={handleSave} />;
};
